import { MenuItemType } from "antd/es/menu/interface";
import { MdOutlineSend, MdOutlineSendAndArchive } from "react-icons/md";
import { Post } from "store/posts/postConstants";
import ConnectSocialsTooltip from "../../components/Utility/ConnectSocialsTooltip";

interface GetDropdownItemsArgs {
  post: Post;
  canPublishPosts: boolean;
  hasConnectedSocials: boolean;
  schedulePost: (args: { post: Post; scheduleType?: string }) => void;
  publishPost: (post: Post) => void;
  customTimeMenuItem: MenuItemType | null; // Expect MenuItemType or null
}

export const getDropdownItems = ({
  post,
  canPublishPosts,
  hasConnectedSocials,
  schedulePost,
  publishPost,
  customTimeMenuItem,
}: GetDropdownItemsArgs): MenuItemType[] => {
  const items: MenuItemType[] = [
    {
      label: "Schedule Next",
      icon: <MdOutlineSendAndArchive size={18} />,
      key: "schedule",
      onClick: () => schedulePost({ post, scheduleType: "schedule-next" }),
    },
  ];

  if (canPublishPosts) {
    items.unshift({
      label: <ConnectSocialsTooltip>Publish Now</ConnectSocialsTooltip>,
      icon: <MdOutlineSend size={18} />,
      key: "publish",
      onClick: () => publishPost(post),
      disabled: !hasConnectedSocials,
    });
  }

  if (customTimeMenuItem) {
    items.push(customTimeMenuItem);
  }

  return items;
};
